if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector('[name="id"]').disabled = false;

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";
        this.error = false;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      changeShippingRuleText(itemCount) {
        const ruleTextElement = document.querySelector(".shippng-rule_text");
        const itemThreshold = 2;

        if (!ruleTextElement) return;

        if (itemCount >= itemThreshold) {
          ruleTextElement.innerHTML =
            'Congrats! you\'ve got <span class="text-colored">free</span> shipping';
        } else {
          const itemsNeeded = itemThreshold - itemCount;
          ruleTextElement.innerHTML =
            `Add ${itemsNeeded} more item${itemsNeeded > 1 ? "s" : ""}` +
            ' to qualify for <span class="text-colored">free</span> shipping!';
        }
      }

      // ✅ Auto-add gift (correct payload: { items: [...] })
      autoAddGiftIfNeeded() {
        const GIFT_VARIANT_ID = 46358866264195;
        const THRESHOLD = 4;

        if (this.__autoGiftAddLock) return Promise.resolve();
        this.__autoGiftAddLock = true;

        return fetch("/cart.js", { credentials: "same-origin" })
          .then((r) => r.json())
          .then((cart) => {
            const nonGiftCount = cart.items
              .filter((item) => item.variant_id !== GIFT_VARIANT_ID)
              .reduce((sum, item) => sum + item.quantity, 0);

            if (nonGiftCount < THRESHOLD) return;

            const hasGift = cart.items.some(
              (item) => item.variant_id === GIFT_VARIANT_ID
            );
            if (hasGift) return;
               const mainCartItems =
                document.getElementById("main-cart-items") ||
                document.getElementById("CartDrawer-CartItems");
                mainCartItems.style.opacity = ".65";


            return fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              credentials: "same-origin",
              body: JSON.stringify({
                items: [
                  {
                    id: GIFT_VARIANT_ID,
                    quantity: 1,
                    properties: { _promo: "Free gift (4+ items)", _auto: "true" },
                  },
                ],
              }),
            });
          })
          .then((res) => {
            if (
              res &&
              res.ok &&
              typeof publish === "function" &&
              typeof PUB_SUB_EVENTS !== "undefined"
            ) {
              // Ask theme to refresh UI (drawer/cart)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "gift-auto-add" });
            }
          })
          .catch((e) => console.warn("[Gift] autoAddGiftIfNeeded failed:", e))
          .finally(() => {
            setTimeout(() => (this.__autoGiftAddLock = false), 100);
             mainCartItems.style.opacity = "1";
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"]; // keep FormData boundary intact

        const formData = new FormData(this.form);

        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);

          if (typeof this.cart.setActiveElement === "function") {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((r) => r.json())
          .then((response) => {
            // Update shipping rule text (non-blocking)
            fetch("/cart.js")
              .then((rr) => rr.json())
              .then((cart) => this.changeShippingRuleText(cart.item_count))
              .catch(() => {});

            // Error from Shopify
            if (response.status) {
              if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (soldOutMessage) {
                this.submitButton.setAttribute("aria-disabled", true);
                const span = this.submitButton.querySelector("span");
                if (span) span.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
              }

              this.error = true;
              return;
            }

            // If no cart UI exists, stop here
            if (!this.cart) return;

            // Success publish
            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }

            // Render cart/drawer contents
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => setTimeout(() => this.cart.renderContents(response)),
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            // ✅ Auto-add gift after successful add-to-cart
            setTimeout(() => {
              this.autoAddGiftIfNeeded();
            }, 250);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");

            if (!this.error) this.submitButton.removeAttribute("aria-disabled");

            const spinner2 = this.querySelector(".loading-overlay__spinner");
            if (spinner2) spinner2.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
